export default __webpack_public_path__ + "static/media/SearchIcon2.2246823f.svg";